import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import React from "react";
import { IEventListData } from "store/eventList/EventList.types";
import { IEventData } from "types";
import {
  EventImage,
  EventImageContainer,
  EventInfo,
  EventItem,
  EventLocation,
  EventName,
  EventTime,
  EventsList as StyledEventsList,
} from "./NewEvents.styles";

interface EventsListProps {
  events: IEventListData[];
  selectedEvent: IEventData | null;
  selectedId: number | null;
  handleSelectEvent: (id: number) => void;
  imageErrors: { [key: number]: boolean };
  handleImageError: (eventId: number) => void;
}

const EventsList: React.FC<EventsListProps> = ({
  events,
  selectedEvent,
  selectedId,
  handleSelectEvent,
  imageErrors,
  handleImageError,
}) => {
  if (events.length === 0) {
    return <p style={{ padding: "1rem" }}>No events found</p>;
  }

  return (
    <StyledEventsList>
      {events.map((ev) => {
        const isSelected = ev.id === selectedId;
        return (
          <EventItem
            key={ev.id}
            className={isSelected ? "selected" : ""}
            onClick={() => handleSelectEvent(ev.id)}
          >
            <EventImageContainer>
              {!imageErrors[ev.id] ? (
                <EventImage
                  src={
                    ev.visuals?.[0]?.image_url ||
                    "https://via.placeholder.com/160"
                  }
                  alt={ev.activity_title}
                  onError={() => handleImageError(ev.id)}
                />
              ) : (
                "No Image Found"
              )}
            </EventImageContainer>
            <EventInfo>
              <EventName>{ev.activity_title}</EventName>
              <EventTime>
                <AccessTimeIcon style={{ fontSize: "16px" }} />
                {new Date(ev.start_date_time).toLocaleString("en-US", {
                  weekday: "short",
                  month: "short",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })}
              </EventTime>
              <EventLocation>
                <LocationOnIcon style={{ fontSize: "16px" }} />
                {ev.places.length > 0
                  ? `${ev.places[0].place_city}, ${ev.places[0].place_state} ${ev.places[0].place_postcode}`
                  : "Unknown"}
              </EventLocation>
            </EventInfo>
          </EventItem>
        );
      })}
    </StyledEventsList>
  );
};

export default EventsList;
